// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-opening-home {
    min-height: 100rem;
    background: #282c34;
}

.case-opening-header {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 24px;
}

.case-opening-name-case {
    color: #fff;
    font-weight: bold;
}

.case-opening-open-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    h2 {
        color: white;
    }
}

.case-opening-open-box-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    margin-top: 15px;
    margin-bottom: 15px;
    border: none;
    width: 200px;
    height: 40px;
    background-color: #344965;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Exo";
    cursor: pointer;
    button {
        align-items: center;
        color: white;
        cursor: pointer;
        background-color: #344965;
        border: none;
        font-family: "Exo";
        font-size: 14px;
    }
    span {
        color: white;
    }
}

.case-opening-background-opening {
    width: 1400px;
    height: 380px;
}

.case-opening-background-case {
    width: 250px;
    height: 200px;
    position: absolute;
    margin-bottom: 80px;
    margin-top: 0;
}

.case-opening-content-box {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
}

.case-opening-content-box-text {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left: 50px;
    padding-right: 0;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    i {
        color: rgb(255, 58, 0);
    }
}

.case-opening-content-box-skin {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 15px;
    gap: 10px;
}

.case-opening-content-box-skin-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 200px;
    height: 170px;
    color: #fff;
    background: #393d49;
    border-radius: 4px;
    margin: 5px;
    padding: 5px;
}

.case-opening-content-box-skin-preview-text {
    display: flex;
    align-items: center;
    gap: 25px;
    font-size: 14px;
    i {
        cursor: pointer;
    }
}

.case-opening-content-box-skin-preview-img {
    width: 140px;
    height: 108px;
}

.case-opening-content-box-skin-preview-weapon-name {
    font-weight: bold;
    color: #d1d1d1;
}

.case-opening-test {
    display: flex;
    justify-content: center;
    align-items: center;
    h2 {
        color: white;
    }
}

.case-opening-reward {
    position: absolute;
}

.roulette-window {
    position: absolute;
}

.reward-card {
    color: white;
}

.case-opening-background-case.hidden {
    opacity: 0;
    transition: opacity 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/styles/OpenCase.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf;QACI,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC","sourcesContent":[".case-opening-home {\r\n    min-height: 100rem;\r\n    background: #282c34;\r\n}\r\n\r\n.case-opening-header {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 24px;\r\n    padding-bottom: 24px;\r\n}\r\n\r\n.case-opening-name-case {\r\n    color: #fff;\r\n    font-weight: bold;\r\n}\r\n\r\n.case-opening-open-box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 16px;\r\n    h2 {\r\n        color: white;\r\n    }\r\n}\r\n\r\n.case-opening-open-box-button {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 3px;\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\r\n    border: none;\r\n    width: 200px;\r\n    height: 40px;\r\n    background-color: #344965;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n    font-family: \"Exo\";\r\n    cursor: pointer;\r\n    button {\r\n        align-items: center;\r\n        color: white;\r\n        cursor: pointer;\r\n        background-color: #344965;\r\n        border: none;\r\n        font-family: \"Exo\";\r\n        font-size: 14px;\r\n    }\r\n    span {\r\n        color: white;\r\n    }\r\n}\r\n\r\n.case-opening-background-opening {\r\n    width: 1400px;\r\n    height: 380px;\r\n}\r\n\r\n.case-opening-background-case {\r\n    width: 250px;\r\n    height: 200px;\r\n    position: absolute;\r\n    margin-bottom: 80px;\r\n    margin-top: 0;\r\n}\r\n\r\n.case-opening-content-box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.case-opening-content-box-text {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding-left: 50px;\r\n    padding-right: 0;\r\n    color: #fff;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    i {\r\n        color: rgb(255, 58, 0);\r\n    }\r\n}\r\n\r\n.case-opening-content-box-skin {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    padding: 15px;\r\n    gap: 10px;\r\n}\r\n\r\n.case-opening-content-box-skin-preview {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 200px;\r\n    height: 170px;\r\n    color: #fff;\r\n    background: #393d49;\r\n    border-radius: 4px;\r\n    margin: 5px;\r\n    padding: 5px;\r\n}\r\n\r\n.case-opening-content-box-skin-preview-text {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 25px;\r\n    font-size: 14px;\r\n    i {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.case-opening-content-box-skin-preview-img {\r\n    width: 140px;\r\n    height: 108px;\r\n}\r\n\r\n.case-opening-content-box-skin-preview-weapon-name {\r\n    font-weight: bold;\r\n    color: #d1d1d1;\r\n}\r\n\r\n.case-opening-test {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    h2 {\r\n        color: white;\r\n    }\r\n}\r\n\r\n.case-opening-reward {\r\n    position: absolute;\r\n}\r\n\r\n.roulette-window {\r\n    position: absolute;\r\n}\r\n\r\n.reward-card {\r\n    color: white;\r\n}\r\n\r\n.case-opening-background-case.hidden {\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
